import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Card } from '../components/ui/Card';

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0A0E27]">
      <Header />
      
      <main className="pt-20 pb-20">
        <div className="container mx-auto px-6 py-12 max-w-4xl">
          <Card className="p-8 md:p-12">
            <h1 className="text-4xl font-bold mb-8 gradient-text">Termos de Uso</h1>
            
            <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
              <p className="text-sm text-gray-400 italic">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">1. Aceitação dos Termos</h2>
                <p>
                  Ao acessar e utilizar o Video Analyzer IA, você concorda em cumprir e estar vinculado aos seguintes Termos de Uso. 
                  Se você não concorda com qualquer parte destes termos, não deve utilizar nosso serviço.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">2. Natureza do Serviço</h2>
                <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 my-4">
                  <p className="font-semibold text-yellow-400 mb-2">⚠️ AVISO IMPORTANTE</p>
                  <p>
                    O Video Analyzer IA é uma plataforma que utiliza tecnologia de Inteligência Artificial (IA) para análise automática 
                    de vídeos do YouTube. <strong>Todas as análises são geradas exclusivamente por algoritmos de IA</strong>, sem intervenção, 
                    revisão ou validação humana prévia. O autor, desenvolvedor e operador desta plataforma <strong>não tem nenhuma relação 
                    ou responsabilidade sobre o conteúdo gerado pela IA</strong>.
                  </p>
                </div>
                <p>
                  Os resultados apresentados são <strong>probabilísticos e indicativos</strong>, não constituindo verdades absolutas, 
                  afirmações definitivas ou conclusões definitivas sobre o conteúdo analisado.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">3. Limitações e Disclaimers</h2>
                
                <h3 className="text-xl font-semibold text-white mt-6 mb-3">3.1. Precisão e Confiabilidade</h3>
                <p>
                  As análises geradas pela IA podem conter erros, imprecisões, omissões ou interpretações equivocadas. 
                  A plataforma não garante a precisão, completude, atualidade ou confiabilidade de qualquer análise gerada.
                </p>
                
                <h3 className="text-xl font-semibold text-white mt-6 mb-3">3.2. Natureza Probabilística</h3>
                <p>
                  Todos os resultados são expressos como <strong>probabilidades e sugestões</strong>, utilizando termos como:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>"Supostamente"</li>
                  <li>"Possivelmente"</li>
                  <li>"Segundo análise automatizada"</li>
                  <li>"Pode indicar"</li>
                  <li>"Sugere que"</li>
                  <li>"De acordo com a análise automatizada"</li>
                </ul>
                <p>
                  Nenhum resultado deve ser interpretado como verdade absoluta ou afirmação definitiva.
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">3.3. Foco no Conteúdo, Não na Pessoa</h3>
                <p>
                  As análises focam exclusivamente no conteúdo dos vídeos analisados, não em seus criadores, apresentadores 
                  ou qualquer pessoa associada. A plataforma não faz acusações pessoais, não atribui intenções específicas 
                  a indivíduos e não utiliza linguagem acusatória ou que sugira criminalidade.
                </p>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">3.4. Não Constitue Aconselhamento</h3>
                <p>
                  As análises não constituem aconselhamento profissional de nenhuma natureza (jurídico, médico, financeiro, etc.). 
                  Os usuários não devem basear decisões importantes exclusivamente nas análises fornecidas pela plataforma.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">4. Isenção de Responsabilidade</h2>
                <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4 my-4">
                  <p className="font-semibold text-red-400 mb-2">🚫 ISENÇÃO DE RESPONSABILIDADE</p>
                  <p>
                    O Video Analyzer IA, seus desenvolvedores, operadores, proprietários e afiliados <strong>não se responsabilizam por</strong>:
                  </p>
                  <ul className="list-disc list-inside ml-4 space-y-2 mt-3">
                    <li>Qualquer dano direto, indireto, incidental ou consequencial resultante do uso das análises</li>
                    <li>Decisões tomadas com base nas análises geradas pela IA</li>
                    <li>Interpretações incorretas ou uso indevido dos resultados</li>
                    <li>Perdas financeiras, danos à reputação ou qualquer outro prejuízo decorrente do uso do serviço</li>
                    <li>Conteúdo gerado pela IA que possa ser considerado ofensivo, incorreto ou prejudicial</li>
                    <li>Erros técnicos, falhas do sistema ou indisponibilidade do serviço</li>
                  </ul>
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">5. Uso do Serviço</h2>
                
                <h3 className="text-xl font-semibold text-white mt-6 mb-3">5.1. Responsabilidades do Usuário</h3>
                <p>Você concorda em:</p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Utilizar o serviço de forma legal e ética</li>
                  <li>Não utilizar os resultados para atividades ilegais ou que violem direitos de terceiros</li>
                  <li>Compreender que as análises são probabilísticas e não definitivas</li>
                  <li>Realizar sua própria verificação antes de tomar decisões baseadas nas análises</li>
                  <li>Não atribuir autoria ou responsabilidade das análises a pessoas físicas ou jurídicas</li>
                </ul>

                <h3 className="text-xl font-semibold text-white mt-6 mb-3">5.2. Vídeos Analisados</h3>
                <p>
                  A plataforma não se responsabiliza pelo conteúdo dos vídeos analisados, que são de responsabilidade exclusiva 
                  de seus criadores e da plataforma YouTube. A análise automática de um vídeo não implica endosso, aprovação 
                  ou reprovação de seu conteúdo pela plataforma.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">6. Propriedade Intelectual</h2>
                <p>
                  As análises geradas são fornecidas "como estão" e podem ser utilizadas pelo usuário para fins pessoais. 
                  No entanto, o usuário deve sempre indicar que se trata de análise automatizada gerada por IA e não atribuir 
                  a autoria ou responsabilidade a terceiros.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">7. Modificações dos Termos</h2>
                <p>
                  Reservamos o direito de modificar estes Termos de Uso a qualquer momento. As alterações entrarão em vigor 
                  imediatamente após a publicação. O uso continuado do serviço após as alterações constitui aceitação dos novos termos.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">8. Lei Aplicável</h2>
                <p>
                  Estes Termos de Uso são regidos pelas leis do Brasil. Qualquer disputa relacionada a estes termos será 
                  resolvida nos tribunais competentes do Brasil.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white mt-8 mb-4">9. Contato</h2>
                <p>
                  Para questões sobre estes Termos de Uso, entre em contato através dos canais de suporte da plataforma.
                </p>
              </section>

              <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 my-8">
                <p className="font-semibold text-blue-400 mb-2">📌 RECAPITULAÇÃO IMPORTANTE</p>
                <p>
                  Ao utilizar o Video Analyzer IA, você reconhece e aceita que: (1) todas as análises são geradas exclusivamente 
                  por IA; (2) os resultados são probabilísticos, não definitivos; (3) a plataforma não se responsabiliza pelo 
                  conteúdo gerado; (4) você deve verificar informações importantes independentemente; e (5) as análises focam no 
                  conteúdo, não em pessoas.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
}
